var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    filter: "url(#tick-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tick-circle_svg__b)",
    fillRule: "evenodd",
    d: "M15 27.5c6.904 0 12.5-5.596 12.5-12.5S21.904 2.5 15 2.5 2.5 8.096 2.5 15 8.096 27.5 15 27.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#tick-circle_svg__c)",
    strokeLinecap: "round",
    d: "M15 27.5c6.904 0 12.5-5.596 12.5-12.5S21.904 2.5 15 2.5 2.5 8.096 2.5 15 8.096 27.5 15 27.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAE3F1",
    fillRule: "evenodd",
    d: "M21.949 11.875a.938.938 0 0 0-1.398-1.25l-4.21 4.704c-.854.953-1.429 1.591-1.92 2.004-.468.394-.743.48-.983.48s-.516-.086-.984-.48c-.491-.413-1.066-1.051-1.92-2.004l-1.086-1.214a.938.938 0 0 0-1.396 1.25l1.132 1.266c.795.888 1.458 1.628 2.064 2.138.64.538 1.332.919 2.19.919s1.548-.38 2.19-.92c.605-.509 1.268-1.249 2.063-2.137z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick-circle_svg__b",
    x1: 15.21,
    x2: 49.715,
    y1: 32.826,
    y2: -0.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tick-circle_svg__c",
    x1: 2.5,
    x2: 27.513,
    y1: 2.5,
    y2: 27.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tick-circle_svg__a",
    width: 74,
    height: 74,
    x: -22,
    y: -22,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_4710"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_1_4710",
    result: "shape"
  })))));
};
export { SvgTickCircle as ReactComponent };